




























import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import * as RouteNames from "@/employer/route-names";
import moment from "moment";
import { formatCurrency } from "@/shared/currency";
import { usePayrollDashboardStore } from "@/employer/store/payrollDashboard";

@Component
export default class UpcomingPayroll extends Vue {
  payrollDashboard = usePayrollDashboardStore();

  formatCurrency = formatCurrency;
  moment = moment;

  @Prop()
  noOfUpcomingPayrolls: number;

  mounted () {
    this.payrollDashboard.initUpcomingPayrolls(this.noOfUpcomingPayrolls);
  }

  get payrollCalendar () {
    return { name: RouteNames.ContributionsCalendar };
  }

  get showUpcomingPayrollDetails () {
    return this.payrollDashboard.showUpcomingPayroll && this.payrollDashboard.upcomingPayrolls.length > 0;
  }
}
